import React, { useState } from 'react';
import Style from './BancoDoAuto25Blog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function BancoDoAuto25Blog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="boleto-conteudos">
        <ContainerHome24>
          <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2>
          <div className="is-mobi">
            {/* <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a href="blog/carros-novos-ou-usados.html" className="boleto-conteudos-card">
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-42/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-42/capa.png" />
                        <img
                          src="static/amp/blog/post-42/capa.png"
                          alt="Carro novo vermelho a frente e pessoas dando as mãos ao fundo"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Carros novos ou usados: qual a melhor escolha para o seu bolso?
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a
                      href="blog/vantagens-financiamento-de-veiculos.html"
                      className="boleto-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-46/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-46/capa.png" />
                        <img
                          src="static/amp/blog/post-46/capa.jpg"
                          alt="mulher sentada em carro vermelho pensando sobre como funciona o financiamento de veículos"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Financiamento de veículos: entenda as vantagens
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a
                      href="blog/melhor-momento-para-trocar-de-carro.html"
                      className="boleto-conteudos-card"
                    >
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-33/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-33/capa.png" />
                        <img
                          src="static/amp/blog/post-33/capa.jpg"
                          alt="casal-querendo-trocar-de-carro-e-vendedora-apresentando-o-automovel"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Descubra o melhor momento para trocar de carro
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            {/* <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <div className="cards-desk">
              <a href="blog/carros-novos-ou-usados.html" className="boleto-conteudos-card">
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-42/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-42/capa.png" />
                  <img
                    src="static/amp/blog/post-42/capa.png"
                    alt="Carro novo vermelho a frente e pessoas dando as mãos ao fundo"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Carros novos ou usados: qual a melhor escolha para o seu bolso?
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/vantagens-financiamento-de-veiculos.html"
                className="boleto-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-46/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-46/capa.png" />
                  <img
                    src="static/amp/blog/post-46/capa.jpg"
                    alt="mulher sentada em carro vermelho pensando sobre como funciona o financiamento de veículos"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Financiamento de veículos: entenda as vantagens
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a
                href="blog/melhor-momento-para-trocar-de-carro.html"
                className="boleto-conteudos-card"
              >
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-33/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-33/capa.png" />
                  <img
                    src="static/amp/blog/post-33/capa.jpg"
                    alt="casal-querendo-trocar-de-carro-e-vendedora-apresentando-o-automovel"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Descubra o melhor momento para trocar de carro
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default BancoDoAuto25Blog;
